import { render, staticRenderFns } from "./ViewMetaData.vue?vue&type=template&id=494aa66c&scoped=true&"
import script from "./ViewMetaData.vue?vue&type=script&lang=js&"
export * from "./ViewMetaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494aa66c",
  null
  
)

export default component.exports